import { styled } from '@mui/material'
import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip'
import intl from 'app/localization/intl'

const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({})

interface NoConnectionsTooltipProps {
  button: React.ReactNode
  placement?: 'top' | 'bottom' | 'left' | 'right'
}

function NoConnectionsTooltip({ button, placement = 'left' }: NoConnectionsTooltipProps) {
  const tooltipText = intl.formatMessage({ id: 'connections.connectionsNewButton.tooltip' })
  const isVerticalPlacement = placement === 'top' || placement === 'bottom'

  return (
    <CustomWidthTooltip
      title={tooltipText}
      placement={placement}
      enterDelay={200}
      arrow
      sx={{
        [`& .${tooltipClasses.tooltip}`]: {
          textAlign: isVerticalPlacement ? 'center' : 'left',
          maxWidth: isVerticalPlacement ? 271 : 298
        }
      }}
    >
      <span style={{ cursor: 'not-allowed', display: 'inline-block' }}>{button}</span>
    </CustomWidthTooltip>
  )
}

export default NoConnectionsTooltip
